import mod from "-!../../../../../../node_modules/babel-loader/lib/index.js??ref--4!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./popover.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../../../node_modules/babel-loader/lib/index.js??ref--4!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./popover.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/popover/popover.vue?vue&type=script&lang=js&
// module id = 480
// module chunks = 0